export type TermsAndConditionsAgreement = {
    readonly accepted: boolean;
};

export enum Supplier {
    VW = 'vw',
    RIO_INTERNAL = 'rio-internal',
    RIO_MONITORING = 'rio-monitoring',
}

export enum ActivationStatus {
    ACTIVE = 'active',
    PENDING = 'pending',
}

export enum FeatureActivationStatus {
    APPROVED = 'approved',
    PENDING = 'pending',
    NONE = 'none',
}

export enum CompoundAccess {
    ACCESS = 'access',
    NO_ACCESS = 'no-access',
}

export type Activation = {
    readonly supplier: Supplier;
    readonly status: ActivationStatus;
};

export type FeatureActivations = {
    readonly activationStatus: FeatureActivationStatus;
    readonly compound: CompoundAccess;
};
